export default {
  PUSH_TASK_GROUP: 'PUSH_TASK_GROUP',
  PUSH_TASK_GROUPS: 'PUSH_TASK_GROUPS',
  REMOVE_TASK_GROUP: 'REMOVE_TASK_GROUP',
  REPLACE_TASK_GROUP: 'REPLACE_TASK_GROUP',
  RESET_TASK_GROUP_STATE: 'RESET_TASK_GROUP_STATE',
  SET_IS_ADDING_TASK_GROUP: 'SET_IS_ADDING_TASK_GROUP',
  SET_SELECTED_TASK_GROUP_GUID: 'SET_SELECTED_TASK_GROUP_GUID',
  SET_TASK_GROUPS_IS_LOADING: 'SET_TASK_GROUPS_IS_LOADING',
  SET_TASK_GROUP_MAP: 'SET_TASK_GROUP_MAP',
  SET_TASK_GROUP_MAP2: 'SET_TASK_GROUP_MAP2',
};
